/**
 * Klavye kisayollari icin ortak koruma.
 *
 * ## Neden ayri bir fonksiyon
 *
 * Ilk hali her dinleyicide `(event.target as HTMLElement)?.closest(...)`
 * yaziyordu ve iki problemi vardi:
 *
 *  1. **`closest` her hedefte YOK.** `event.target` `document` olabiliyor
 *     (programatik `dispatchEvent`) ve `document.closest` tanimsiz - yani
 *     koruma satiri `TypeError` firlatip TUM dinleyiciyi dusuruyor. Kisayol
 *     sessizce calismaz hale geliyor ve sebebi hicbir yerde gorunmuyor.
 *  2. Ayni mantik uc yerde tekrarlaniyordu; biri gunun birinde
 *     `[contenteditable]`i kacirirdi.
 *
 * `instanceof Element` kontrolu ikisini de kapatiyor.
 */

/** Kullanici bir metin alanina mi yaziyor? Oyleyse kisayol CALISMAMALI. */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false
  return target.closest('input, textarea, select, [contenteditable]') !== null
}
